import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=7b06dcb0&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=7b06dcb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b06dcb0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainInteresting: require('/web/components/MainInteresting.vue').default,MainExperts: require('/web/components/MainExperts.vue').default,MainArts: require('/web/components/MainArts.vue').default,MainObjects: require('/web/components/MainObjects.vue').default})
